(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .factory('ProtocolCategory', ProtocolCategoryFactoryFn);

    ProtocolCategoryFactoryFn.$inject = ['Item'];

    function ProtocolCategoryFactoryFn(Item) {

        var ProtocolCategory = function () {

            // default values
            this.caption = null;
            this.deleted = false;
            this.sortOrder = 0;

            // extend object
            function extend(category) {
                var self = this;
                angular.extend(self, category);
            } // extend

                  //public
            this.extend = extend;
        };

        // extend
        ProtocolCategory.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        }

        return ProtocolCategory;
    }
})();